export const LANGS: {
  [x: string]: { code: string; name: string; countrycode: string; flag: string }
} = {
  en: {
    code: 'en',
    name: 'English',
    countrycode: 'gb',
    flag: '/images/flags/uk.png',
  },
  'zh-CN': {
    code: 'zh-CN',
    name: 'Chinese',
    countrycode: 'zh-CN',
    flag: '/images/flags/ch-flag.png',
  },
}
